export default class VisibleInterval {

    private isVisible: boolean;
    private isIntervalDue: boolean;
    private interval: any;
    private intervalFunction: (args?: any) => void;
    private intervalTime: number;
    private args?: any;

    constructor(intervalFunction: (args?: any) => void, intervalTime: number, args?: any) {
        let me = this;

        me.isVisible = true;
        me.isIntervalDue = false;
        me.intervalTime = intervalTime;
        me.intervalFunction = intervalFunction;
        me.args = args;

        $(document).on("visibilitychange", () => {
            me.isVisible = document.visibilityState === "visible";

            if (me.isVisible) {
                if (me.isIntervalDue) {
                    me.intervalFunction(me.args);
                    me.isIntervalDue = false;
                    me.start();
                }
            }
        });
    }

    start() {
        var me = this;

        me.stop();
        me.interval = setInterval(function () {
            if (me.isVisible) {
                me.intervalFunction(me.args);
            } else {
                me.isIntervalDue = true;
                me.stop();
            }
        }, me.intervalTime);
    }

    stop() {
        var me = this;
        clearInterval(me.interval);
    }
}
